export const releaseVersion = "1.16";
export const snapshotVersion = "1.16";
export const defaultVersion = releaseVersion;
export const versionKeys = {
    "1.13": 0,
    "1.14": 1,
    "1.15": 2,
    "1.16": 3
};
export function versionAtLeast(version, minVersion) {
    return versionKeys[version] >= versionKeys[minVersion];
}
